import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './auth.component';
import { CodeLostComponent } from './code-lost/code-lost.component';
import { LockIdentityComponent } from './lock-identity/lock-identity.component';
import { LoginComponent } from './login/login.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PasswordLostComponent } from './password-lost/password-lost.component';
import { UsernameLostComponent } from './username-lost/username-lost.component';
import { PasswordModifyComponent } from './password-modify/password-modify.component';
import { AppPaths } from 'src/enums/app-paths';
import { EmailVerifyComponent } from './email-verify/email-verify.component';
import { ActivationGuard } from './activation.guard';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '', component: LoginComponent,
      },
      {
        path: AppPaths.UsernameLost,
        component: UsernameLostComponent,
        pathMatch: 'full',
      },
      {
        path: AppPaths.PasswordLost,
        component: PasswordLostComponent,
      },
      {
        path: AppPaths.CodeLost,
        component: CodeLostComponent,
      },
      {
        path: AppPaths.LockIdentity,
        component: LockIdentityComponent,
      },
      {
        path: AppPaths.PasswordReset,
        component: PasswordResetComponent,
      },
      {
        path: AppPaths.PasswordModify,
        component: PasswordModifyComponent,
      },
      {
        path: AppPaths.EmailVerify + "/:token",
        component: EmailVerifyComponent,
      },
      {
        path: "**",
        component: AuthComponent,
      },
    ]
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class AuthRoutingModule { }
